export const accountAction = {
  loadAccounts: (state, action) => {
    state.accounts = action.payload;
  },

  loadAllAccounts: (state, action) => {
    state.allAccounts = action.payload;
  },

  loadAccountsMapper: (state, action) => {
    state.accountsMapper = action.payload;
  },
};
